var _path, _path2, _path3, _path4, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163 90 A72 72 0 1 0 110 168",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 12,
    strokeLinecap: "round",
    transform: "translate(3,3)",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163 90 A72 72 0 1 0 110 168",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 12,
    strokeLinecap: "round",
    transform: "translate(-3,-3)",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163 90 A72 72 0 1 0 110 168",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163 90 A72 72 0 1 0 110 168",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 4,
    strokeLinecap: "round",
    transform: "translate(3,3)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "163,90 138,66 148,100",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "166,93 141,69 151,103",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.b9a3aabc6b6dd63151407c0441efbd9f.svg";
export { ForwardRef as ReactComponent };